export default "__VITE_ASSET__15578dfe__"